import { DOUBLE_CONSENT_AGREE, DOUBLE_CONSENT_HIDE, DOUBLE_CONSENT_SHOW } from './TermsPageConstants';

export default (state = false, action) => {
    switch (action.type) {
        case DOUBLE_CONSENT_AGREE:
            return false;
        case DOUBLE_CONSENT_SHOW:
            return true;
        case DOUBLE_CONSENT_HIDE:
            return false;
        default:
            return state;
    }
};
